import { IOSNames } from '../types'

type ScriptMessage = {
  name: IOSNames
  message?: string
}

declare const window

/*
 *  window.webkit may not be immediately available so
 *  we need a small delay
 */
export const postMessage = (args: ScriptMessage) => {
  setTimeout(() => {
    if (typeof window.webkit !== 'undefined') {
      window.webkit.messageHandlers.iOSDasherClient.postMessage(args)
    }
  }, 0)
}
